import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-modal-error-list',
  templateUrl: './modal-error-list.component.html',
  styleUrls: ['./modal-error-list.component.scss']
})
export class ModalErrorListComponent {
  @Output() close = new EventEmitter<any>();
  @Input() errors: any[] = null;

  constructor() {
    
  }
}
